import React from "react";

const ProductOverview = () => {
  return (
    <div className="flex-1 flex-col h-fit w-full  radius-10 back-white  align-left justify-start  pt-3 pb-2 pl-3 pr-3 g-2">
      <div className="w-full flex-col align-left justify-start g-1">
        <h3 className="t-16 color-grayColor poppins-medium weight-500">
          Product overview
        </h3>
        <hr color="#e5e5e5" className="w-full" />
      </div>
      <div className="flex-col flex-1 scroll-y align-left justify-start g-2 w-full">
        <div className="flex-col align-left justify-start g-1 w-full flex-1">
          <h4 className="t-14 weight-500 poppins color-grayColor">
            Software summary
          </h4>
          <p className="t-12 poppins color-textColor">
            OMS is an all-in-one SaaS solution designed to support the daily
            operations of educational institutions—whether residential or
            non-residential. This software helps schools, colleges, and training
            centers efficiently manage administrative, academic, financial, and
            organizational tasks through a centralized system. With OMS,
            institutions can handle student data, staff records, fee
            collections, hostel arrangements, attendance tracking, and more with
            ease. The platform is built to simplify complex workflows, reduce
            manual effort, and enhance productivity across departments. A key
            strength of OMS is its multi-level admin control. The main
            administrator can assign roles to multiple Act Admins and Sub
            Admins, ensuring secure access and smooth delegation of
            responsibilities. This structured hierarchy supports better team
            coordination and data security. The software provides real-time
            dashboards, automated reporting tools, and smart notifications to
            keep users informed and organized. From classroom to hostel, and
            accounts to academics, OMS connects every function under one roof.
            By going digital with OMS, institutions can eliminate paperwork,
            minimize errors, and improve communication among staff, students,
            and parents. It’s a powerful, scalable, and user-friendly platform
            tailored to meet the evolving needs of modern education systems.
          </p>
        </div>
        <div className="flex-col align-left justify-start g-1 w-full flex-1">
          <h4 className="t-14 weight-500 poppins color-grayColor">User flow</h4>
          <p className="t-12 poppins color-textColor">
            Onboarding{">>"}Settings{">>"}Personal details{">>"}Institutional
            details{">>"}Import input details{">>"}Set organizational part{">>"}Set
            operational part{">>"}set financial part.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProductOverview;
